import { useRef, useEffect } from 'react';

let styleInjected = false;

function injectStyles() {
  if (styleInjected) return;
  styleInjected = true;
  const style = document.createElement('style');
  style.textContent = `
    @keyframes skeleton-shimmer {
      0% { background-position: -200px 0; }
      100% { background-position: calc(200px + 100%) 0; }
    }
  `;
  document.head.appendChild(style);
}

export default function Skeleton({ width = '100%', height = 16, borderRadius = 8, style = {}, theme: t }) {
  useEffect(() => { injectStyles(); }, []);

  const base = t?.cardBorder || '#e2e8f0';
  const highlight = t?.tableHover || '#f1f5f9';

  return (
    <div
      style={{
        width,
        height,
        borderRadius,
        background: `linear-gradient(90deg, ${base} 25%, ${highlight} 50%, ${base} 75%)`,
        backgroundSize: '200px 100%',
        animation: 'skeleton-shimmer 1.5s ease-in-out infinite',
        ...style,
      }}
    />
  );
}

export function SkeletonCard({ theme: t, height = 80, children }) {
  return (
    <div
      style={{
        background: t?.cardBg || 'white',
        borderRadius: 14,
        padding: 18,
        boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
        border: '1px solid ' + (t?.cardBorder || '#eee'),
        height,
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        justifyContent: 'center',
      }}
    >
      {children || (
        <>
          <Skeleton width="40%" height={10} theme={t} />
          <Skeleton width="60%" height={22} theme={t} />
        </>
      )}
    </div>
  );
}
